export default "__VITE_ASSET__Df7lUYRp__"